// components/SubscriptionCard.js
import React, { useContext } from 'react';
import {
    Card,
    CardContent,
    Stack,
    Typography,
    Box,
    Button,
    Skeleton,
    IconButton,
} from '@mui/material';
import { useEffect, useState } from "react";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useTheme } from '@mui/material/styles';
// import ManageSubscription from 'src/pages/ManageSubscription';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { API_SERVICE_BACKEND } from 'src/config';
import toast from 'react-hot-toast';
import axios from "axios";

import ArrowBack from '@mui/icons-material/ArrowBack';
import { WhiteLabelConfigurationContext } from 'src/contexts/ClientConfiguration';
import moment from 'moment';


const SubscriptionCard = ({ subscriptionDetails, loading, userDetails, currentSubscription, setCurrentSubscription
}) => {
    const theme = useTheme();



    useEffect(() => {
        if (!userDetails) return;

        const base = userDetails?.userSubscription?.subscriptions?.base;

        if (base?.planId === '7-day') {
            setCurrentSubscription('trial');
        } else if (base) {
            setCurrentSubscription(base.packageName || 'No Active Subscription');
        } else {
            setCurrentSubscription('No Active Subscription');
        }
    }, [userDetails]);

    const handleManageSubscription = async () => {
        try {
            const baseURL = `${API_SERVICE_BACKEND}/createCustomerPortalSession?userEmail=${encodeURIComponent(sessionStorage.getItem("userEmail"))}`;
            const response = await axios.get(baseURL);
            if (response?.data?.urls?.length > 0) {
                for (const url of response.data.urls) {
                  window.open(url, "_blank");
                }
              }
        } catch (error) {
            //console.log(error);
            toast.error(error?.response?.data?.error || error?.message);
        }
    }


    useEffect(() => {
        //console.log("subscriptionDetails", subscriptionDetails);
        //console.log("userDetails", userDetails);
    }, [subscriptionDetails, userDetails]);
    const {subUserStatus } = useContext(WhiteLabelConfigurationContext);

    const hasActiveSubscription = currentSubscription && currentSubscription !== 'No Active Subscription';

    return (
        //<Stack sx={{ width: { xs: "100%", md: "49%",marginLeft:"4px" } }} spacing={2}>
        <Card
            sx={{
                //marginTop: '10px',
                // width: { xs: "100%", md: "49%" },
                width: "100%",
                border: '1px solid #EAECF0',
                borderRadius:"8px",
            }}
            className="glass-wrapper"
        >
            <CardContent>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Stack direction="row" gap={1} alignItems="center">
                        <Typography
                            className="subHeadding"
                            sx={{ fontWeight: 700, fontSize: '16px', color: theme.palette.text.primary }}
                        >
                            Current Subscription
                        </Typography>
                    </Stack>

                    <Typography sx={{ fontSize: '12px', color: theme.palette.text.secondary, marginTop: "4px" }}>
                        Overview and details of your current subscription plan.
                    </Typography>

                    <div style={{ marginTop: '0px' }}>
                        <Stack direction="column" spacing={2} sx={{ fontSize: '14px', mt: 2 }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    height: '48px',
                                    px: 2,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    backgroundColor: 'background.paper',
                                    boxShadow: 1,
                                    fontSize: '14px',
                                }}
                                className="glass-input"
                            >
                                <Typography sx={{ color: 'text.primary', userSelect: 'none' }}>
                                    {currentSubscription === 'trial'
                                        ? '7 Days Free Trial'
                                        : currentSubscription || 'No Active Subscription'}
                                </Typography>
                                {!userDetails?.whiteLabelUserId &&
                                !subUserStatus &&
                                !userDetails?.isVIPUser && (
                                    <Button
                                        size="small"
                                        variant="contained"
                                        onClick={handleManageSubscription}
                                        sx={{ height: '36px', minWidth: '60px', padding: '0 12px' }}
                                        disabled={userDetails?.hasTeamMemberLimitedAccess}
                                    >
                                        Manage Subscription
                                    </Button>
                                )}


                            </Box>
                        </Stack>
                    </div>

                    {hasActiveSubscription && (
                      <Stack
                        direction="row"
                        alignItems="center"
                        gap={1.5}
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            overflowY: "hidden",
                            whiteSpace: "nowrap",
                            mt: 5,
                            overflowX: "auto",
                            "&::-webkit-scrollbar": {
                                display: "none"
                            }
                        }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', gap: 0.5 }}>
                            <CalendarTodayIcon sx={{ fontSize: 18, color: theme.palette.primary.main, mt: "-3px" }} />

                            <Typography sx={{ fontSize: '14px', color: theme.palette.text.secondary }}>
                                Purchased on: 
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: theme.palette.text.primary,
                                    ml: "4px !important"
                                }}
                            >
                                {loading ? (
                                  <Skeleton width={100} />
                                ) : subscriptionDetails?.startDate ? (
                                  moment(new Date(subscriptionDetails.startDate)).format("MMM DD, YYYY")
                                ) : (
                                  'Not available'
                                )}
                            </Typography>

                        </Box>



                        <Box sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', gap: 0.3 }}>
                            <AutorenewIcon sx={{ fontSize: 20, color: theme.palette.primary.main, mt: "1px" }} />

                            <Typography sx={{ fontSize: '14px', color: theme.palette.text.secondary, mr: 0.5 }}>
                                Resets on:
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    color: theme.palette.text.primary,
                                    ml: "4px !important"
                                }}
                            >
                                {loading ? (
                                  <Skeleton width={100} />
                                ) : subscriptionDetails?.resetsAt ? (
                                  moment(new Date(subscriptionDetails.resetsAt)).format("MMM DD, YYYY")
                                ) : (
                                  'Does not reset'
                                )}
                            </Typography>

                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', gap: 0.5 }}>
                                <AccessTimeIcon sx={{ fontSize: 18, color: theme.palette.primary.main, mt: "-1px" }} />

                                <Typography sx={{ fontSize: '14px', color: theme.palette.text.secondary, mr: 0.5 }}>
                                    Expires on:
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: '13px',
                                        fontWeight: 500,
                                        color: theme.palette.text.primary,
                                        ml: "4px !important"
                                    }}
                                >
                                    {loading ? (
                                      <Skeleton width={100} />
                                    ) : subscriptionDetails?.endDate ? (
                                      moment(new Date(subscriptionDetails.endDate)).format("MMM DD, YYYY")
                                    ) : (
                                      'No expiry (unlimited)'
                                    )}
                                </Typography>

                            </Box>
                    </Stack>
                    )}


                </div>
            </CardContent>
        </Card>
        // </Stack>
    );
};

export default SubscriptionCard;
